import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { Loading } from "@/layouts/components";
import { RoutesList } from "@/router/routesList";
import { useDeletePlaceMutation, useGetPlaceByIdQuery } from "@/store/api";
import { useSetPageData } from "@/tools/hooks";
import { convertToViewModel } from "../common/mappers/convertToViewModel";
import { PlaceDetails } from "./components/PlaceDetails";
/** Страница площадки */
export var PlaceDetailsPage = function () {
    var placeId = useParams().placeId;
    var navigate = useNavigate();
    var placeGetState = useGetPlaceByIdQuery({ id: placeId });
    var _a = useDeletePlaceMutation(), placeDeleteAction = _a[0], placeDeleteState = _a[1];
    var editClickHandler = function () {
        navigate(RoutesList.Place.getPlaceEdit(placeGetState.data.id));
    };
    var deleteClickHandler = function () {
        placeDeleteAction({ id: placeId });
    };
    useEffect(function () {
        if (placeDeleteState.isSuccess) {
            navigate(RoutesList.Place.getPlacesList());
        }
    }, [placeDeleteState.isSuccess]);
    var onSchedulesClickHandler = function () {
        navigate(RoutesList.Place.getPlaceSchedules(placeId));
    };
    var onScheduleTemplatesClickHandler = function () {
        navigate(RoutesList.Place.getPlaceScheduleTemplates(placeId));
    };
    useSetPageData({ title: "Площадка" });
    return (_jsxs(_Fragment, { children: [_jsx(Loading, { isActive: placeGetState.isFetching || placeDeleteState.isLoading, loadingKey: "placeDetails" }), placeGetState.isSuccess && (_jsx(PlaceDetails, { data: convertToViewModel(placeGetState.data), onEditClick: editClickHandler, onDeleteClick: deleteClickHandler, onSchedulesClick: onSchedulesClickHandler, onScheduleTemplatesClick: placeGetState.data.meta.canEdit
                    ? onScheduleTemplatesClickHandler
                    : undefined }))] }));
};
